module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdBAMAAACkvXo8AAAAG1BMVEUAAAD////////////////////////////////rTT7CAAAACHRSTlMAnajbenkmnrlZttYAAAB1SURBVBjTZdEtDoAwDIbhorCTSCQSOYlEEk5AOAV2rscm2ZfsTdqZdX26f3svo92PbY3h5KudXsZ48cNmb4N7+HkZXJSFSfeePCyAJbBITIGYgtqZgs606rtlz/Pz+nl/zhfPD9OF+8f3gRXBCuP7x/+J//cD1OMwD1JgL90AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/ic-tab-close.png
// module id = B2uX
// module chunks = 1